import { Link } from "react-router-dom";

export const LegalPage = ({ title, updated, testId, lede, children }) => (
  <div className="min-h-screen overflow-x-clip bg-[#F7F3EA] font-sans text-[#1A120C]" data-testid={testId}>
    <header className="border-b border-[#C4A36A]/25 bg-[#F7F3EA]">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid={`${testId}-logo`}>
          <img src="/assets/hero-crest.png?v=2" alt="" className="h-10 w-auto" />
          <span className="font-serif text-sm font-medium uppercase tracking-[0.22em] text-[#A08448]">
            Community Hearts
          </span>
        </Link>
        <Link
          to="/"
          className="text-[11px] font-medium uppercase tracking-[0.18em] text-[#A08448] transition-colors hover:text-[#7A5A14]"
          data-testid={`${testId}-back-link`}
        >
          Back to the site
        </Link>
      </div>
    </header>
    <main className="relative z-[1] mx-auto max-w-4xl px-6 py-16 md:py-24">
      <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-[#A08448]" data-testid={`${testId}-updated`}>
        {updated}
      </p>
      <h1
        className="mt-4 font-serif text-4xl font-medium tracking-tight text-[#1A120C] md:text-6xl"
        data-testid={`${testId}-title`}
      >
        {title}
      </h1>
      {lede ? (
        <p className="mt-5 max-w-xl font-serif text-xl italic text-[#A08448] md:text-2xl" data-testid={`${testId}-lede`}>
          {lede}
        </p>
      ) : null}
      <span className="mt-8 block h-px w-16 bg-[#C4A36A]" aria-hidden="true" />
      <div className="mt-12 space-y-10">{children}</div>
    </main>
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-serif text-2xl font-medium tracking-tight text-[#1A120C]">{title}</h2>
    <div className="mt-3 space-y-3 font-serif text-base leading-relaxed text-[#3A2C20]">{children}</div>
  </section>
);
